export const SHOW_TOAST = '@SnackBar/SHOW_TOAST';
export const HIDE_TOAST = '@SnackBar/HIDE_TOAST';

export const showToast = (message, duration = 3000) => async (dispatch) => {
  dispatch({ type: SHOW_TOAST, message });
  setTimeout(() => {
    dispatch({ type: HIDE_TOAST });
  }, duration);
};
